import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "../../auth/auth.service";
import { UserModel } from "../../model/user.model";
import { AddSuccessSnackbarComponent } from "../add-success-snackbar/add-success-snackbar.component";

@Component({
  selector: "app-trainee-add-dialog",
  templateUrl: "./trainee-add-dialog.component.html",
  styleUrls: ["./trainee-add-dialog.component.css"],
})
export class TraineeAddDialogComponent implements OnInit {
  newItem: any;
  addMessage: string = null;
  errorMessage: string = "";
  isLoading: boolean = true;
  mItems: UserModel[];
  durationInSeconds = 1;

  constructor(
    private fb: FormBuilder,
    private mApiService: AuthService,
    private _snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<TraineeAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.newItem = this.data;
  }

  getTrainneListAll() {
    this.mItems = [];
    this.isLoading = true;

    this.mApiService.getTrainees().subscribe(
      (p) => {
        this.mItems = p;
      },
      (e) => (this.errorMessage = e),
      () => (this.isLoading = false)
    );
  }

  onlyNumberKey(event) {
    let ASCIICode = event.which ? event.which : event.keyCode;
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) return false;
    return true;
  }

  public saveNewItem() {
    this.addMessage = null;
    this.newItem.UserRole = "Student";

    this.mApiService.addUser(this.newItem).subscribe(
      (p) => {
        if (p.Success == 0) {
          this.dialogRef.close();

          this._snackBar.openFromComponent(AddSuccessSnackbarComponent, {
            duration: this.durationInSeconds * 1000,
          });
          // this.addModal.close('1');
          this.newItem = new UserModel();
          this.getTrainneListAll();
        } else {
          this.addMessage = p.Message;
        }
      },
      (e) => (this.errorMessage = e),
      () => (this.isLoading = false)
    );
  }
}
